"use client";
import { ModalEnum } from "@/components/Box/types";
import { useRouter } from "@/i18n/routing";
import { Loading, Mask } from "antd-mobile";
import clsx from "clsx";
import React from "react";
import dialogManage from "../manager";
import styles from "./index.module.scss";

const ImgDialog = () => {
    const keyName = "ImgDialog"; // 确保这个keyName是唯一的，与其他地方的keyName不同，以避免冲突
    const [data, setData] = React.useState<any>({});
    const [visible, setVisible] = React.useState<boolean>(false); // 初始值为false，不显示对话框
    const [innerVisible, setInnerVisible] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<number>(0); // 0 |1|2
    const [isCheck, setIsCheck] = React.useState<boolean>(false);

    const router = useRouter();

    const handler = {
        key: keyName,
        show(data: any, idx: number) {
            if (!data) return "close";
            setData(data);
            loadImage();
            setVisible(true);
            setTimeout(() => {
                setInnerVisible(true);
            }, 10);
        },
        hide() {
            setData({});
            setVisible(false);
        },
    };
    React.useEffect(() => {
        dialogManage.registerDialog(handler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadImage = () => {
        if (data?.content?.image) {
            setLoading(1);
            const img = new Image();
            img.src = data?.content?.image;
            img.onload = () => {
                setLoading(0);
            };
            img.onerror = () => {
                setLoading(2);
            };
        } else {
            setLoading(2);
        }
    };

    const close = () => {
        setInnerVisible(false);
        setTimeout(() => {
            if (data?.isShowNotShow) {
                dialogManage.hideDialog(keyName, `close_${isCheck ? 1 : 0}`);
            } else {
                dialogManage.hideDialog(keyName, `close`);
            }
            setIsCheck(false);
        }, 250);
    };

    const doFun = async () => {
        switch (data.action_type) {
            case 2:
                window.open(data.action_params, "_blank");
                break;
            case 3:
                let path = data.action_params;
                if (data.activity_id) {
                    path = `${data.action_params}?activity_id=${data.activity_id}`;
                }
                if (path) {
                    router.push(path);
                }
                break;
            case 4:
                if (data.action_params === ModalEnum.red_packet) {
                    dialogManage.showDialog("RedPacket");
                }
                if (data.action_params === ModalEnum.pwa_install) {
                    dialogManage.showDialog("PwaInstall");
                }
                break;
            case 5:
                data?.action_params ? await eval(data?.action_params || "") : "";
                break;
            default:
                break;
        }
        setInnerVisible(false);
        setTimeout(() => {
            handler.hide();
            dialogManage.goTarget(keyName);
        }, 250);
    };

    return (
        <>
            <Mask visible={visible} onMaskClick={close}>
                <div className={styles.imgDialogWrap}>
                    <div className={styles.imgDialog}>
                        <div
                            className={clsx(styles.imgDialogContainer, {
                                [styles.visible]: innerVisible,
                            })}
                        >
                            <div className="relative h-[100%]">
                                <img src={data?.content?.image} alt="" onClick={doFun} />
                                {loading === 1 && (
                                    <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center bg-[#000]">
                                        <Loading></Loading>
                                    </div>
                                )}
                            </div>
                            <div className={clsx(styles.close)} onClick={close}>
                                <i
                                    className={clsx(
                                        "iconfont icon-guanbi relative z-10 text-[.14rem]"
                                    )}
                                ></i>
                            </div>
                        </div>
                    </div>
                    {data.isShowNotShow && (
                        <div
                            className="flex items-center justify-center py-[.08rem]"
                            onClick={() => {
                                setIsCheck(!isCheck);
                            }}
                        >
                            <div
                                className={clsx(
                                    "mr-[.1rem] flex h-[20px] w-[20px] items-center justify-center border",
                                    {
                                        "border-[#11de68]": isCheck,
                                    }
                                )}
                            >
                                {isCheck && (
                                    <i className="iconfont icon-gouxuan text-[#11de68]"></i>
                                )}
                            </div>
                            <div>Não pop-up desta vez</div>
                        </div>
                    )}
                </div>
            </Mask>
        </>
    );
};

export default ImgDialog;
